// extracted by css-extract-rspack-plugin
export default {"cls1":"TasteOfMentionsUpsellCard-cls1_A80","cls2":"TasteOfMentionsUpsellCard-cls2_11T TasteOfMentionsUpsellCard-cls1_A80"};